import styled from 'styled-components';
import {Button} from 'react-bootstrap';
import {tint} from 'theme/helper';

// The furniture the Drawer Layout card is built from, shared so the cabinet
// and the standalone drawer face panel cannot drift apart.

export const Card = styled.div`
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(20, 60, 110, 0.14);
    margin-bottom: 14px;
`;

export const CardHeader = styled.div`
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    padding: 11px 18px;
    border-bottom: 1px solid
        ${({theme}) => tint(theme.colors.primary?.main, 0.12)};
    background: ${({theme}) => tint(theme.colors.primary?.main, 0.05)};
    font-size: 15px;
    font-weight: 700;
    color: ${({theme}) => theme.colors.primary?.main};

    .more-info button {
        line-height: 0;
        transform: translateY(-1px);
    }
`;

export const Spacer = styled.div`
    flex: 1;
`;

export const ResetButton = styled(Button)`
    &&& {
        font-size: 0.8rem !important;

        img {
            width: 16px;
        }
    }
`;

export const InfoText = styled.span`
    display: inline-block;
    max-width: 260px;
`;

// the bar the pointer takes hold of on a face boundary
export const Grip = styled.span<{$dragging: boolean}>`
    display: block;
    width: ${({$dragging}) => ($dragging ? 96 : 62)}px;
    height: ${({$dragging}) => ($dragging ? 5 : 4)}px;
    border-radius: 3px;
    box-shadow: 0 0 0 2px #fff;
    background: ${({$dragging, theme}) =>
        $dragging
            ? theme.colors.primary?.main
            : tint(theme.colors.primary?.main, 0.55)};
`;

// the controls for the selected face, beside the drawing
export const Panel = styled.div`
    flex: 1 1 0;
    /* below its own content it would be squeezed and overflow the card
       sideways, so it takes a line of its own instead */
    min-width: 280px;
    border: 1px solid ${({theme}) => tint(theme.colors.primary?.main, 0.18)};
    border-radius: 6px;
    background: ${({theme}) => tint(theme.colors.primary?.main, 0.05)};
`;

export const Heading = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    font-weight: 700;
    color: ${({theme}) => theme.colors.primary?.main};
`;

export const Badge = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 4px;
    background: ${({theme}) => theme.colors.primary?.main};
    color: #fff;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;
